import { getRequest } from 'config/Axios/baseConfig';
import { ScheduleAttainmentByRoomResponse } from 'screens/ScheduleAttainmentScreen/components/ScheduleAttainmentByRoomScreen/scheduleAttainmentbyRoom.type';
import { ScheduleAttainmentCalculatorResponse } from 'screens/ScheduleAttainmentScreen/components/ScheduleAttainmentCalculatorScreen/scheduleAttainementCalculator.type';
import { ScheduledRoomResponse } from 'screens/ScheduleAttainmentScreen/components/ScheduledRooms/scheduleRoom.type';

export const scheduleAttainementScreenServices = {
  getScheduleAttainmentCalculatorData: async (): Promise<ScheduleAttainmentCalculatorResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await getRequest<ScheduleAttainmentCalculatorResponse>(
          'pps/schedule-attainment/get-schedule-calculator/'
        );
        resolve(response.data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getScheduledRooms: async (): Promise<ScheduledRoomResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await getRequest<ScheduledRoomResponse>(
          'pps/schedule-attainment/get-scheduled-rooms/'
        );
        resolve(response.data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getScheduleAttainmentByRoom: async (): Promise<ScheduleAttainmentByRoomResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await getRequest<ScheduleAttainmentByRoomResponse>(
          'pps/schedule-attainment/get-room-wise-attainment/'
        );
        resolve(response.data);
      } catch (error) {
        reject(error);
      }
    });
  }
};
